export default __webpack_public_path__ + "static/media/linkurl.10ce7c9a.svg";